import { render } from "./authLayout.vue?vue&type=template&id=7dc55736"
import script from "./authLayout.vue?vue&type=script&lang=js"
export * from "./authLayout.vue?vue&type=script&lang=js"

import exportComponent from "F:\\work\\angren\\cabinet\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__